function Footer() {
  return (
    <footer>
      <p>COPYRIGHTS &copy; 2024 ZIAD AYMAN. &nbsp; All rights reserved.</p>
    </footer>
  );
}

export default Footer;
